import { ReactElement, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { PAGE_ICONS } from 'pages/AnnualUserAccessReview/_const';
import PageWithBreadcrumbs from 'pages/AnnualUserAccessReview/layouts/UARPageWithBreadcrumbs';
import HelpBar, {
	Main,
} from 'pages/ApplicationRequest/components/containers/1616BridgesEpic/components/HelpBar';
import Typography from '@mui/material/Typography';
import FormLayout from 'layouts/FormLayout';
import HelpLayout from 'layouts/HelpLayout';
import DelegateForm from './DelegateForm';

/**
 * Page where manager can grant review privileges to another direct report
 * @returns {ReactElement} User Access Review Employee Delegate Page View
 */
const DelegateView = () => {
	const [sOpen, setOpen] = useState(false);
	return (
		<PageWithBreadcrumbs
			currentPageLabel={'Delegate Review Privileges'}
			CurrentPageIcon={PAGE_ICONS.DELEGATE}
		>
			<CssBaseline />
			<Main open={sOpen}>
				<FormLayout
					title={'Delegate User Access Review'}
					setOpen={() => setOpen(!sOpen)}
				>
					<DelegateForm open={sOpen} />
				</FormLayout>
			</Main>
			<HelpBar open={sOpen} setOpen={setOpen}>
				<HelpLayout title='Delegate User Access Review functions'>
					<Typography>
						The IMS Delegate utility lets UPMC managers grant their
						IMS access privileges to other UPMC staff members. This
						tool is especially useful if you are a manager who has
						large numbers of direct reports. By using the tool you
						can transfer IMS privileges, such as performing Annual
						User Access Reviews, to your delegates
					</Typography>
					<Typography>
						For more information, please check on{' '}
						<a
							href='https://infonet.upmc.com/infonet/ls/content/3827978154242953/delegate-annual-access-review-pdf-1764800023'
							target='_blank'
							rel='noopener noreferrer'
						>
							InfoNet.
						</a>
					</Typography>
				</HelpLayout>
			</HelpBar>
		</PageWithBreadcrumbs>
	);
};

export default DelegateView;
